import React from 'react';
import { SvgComponentProps } from './svg-type';

export default function CopyIcon({
  height = 20,
  width = 20,
  color = '#B3B3B3',
}: SvgComponentProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_6763_3041"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20">
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6763_3041)">
        <path
          d="M7.5 14.9993C7.04167 14.9993 6.64931 14.8362 6.32292 14.5098C5.99653 14.1834 5.83333 13.791 5.83333 13.3327V3.33268C5.83333 2.87435 5.99653 2.48199 6.32292 2.1556C6.64931 1.82921 7.04167 1.66602 7.5 1.66602H15C15.4583 1.66602 15.8507 1.82921 16.1771 2.1556C16.5035 2.48199 16.6667 2.87435 16.6667 3.33268V13.3327C16.6667 13.791 16.5035 14.1834 16.1771 14.5098C15.8507 14.8362 15.4583 14.9993 15 14.9993H7.5ZM4.16667 18.3327C3.70833 18.3327 3.31597 18.1695 2.98958 17.8431C2.66319 17.5167 2.5 17.1243 2.5 16.666V5.83268C2.5 5.59657 2.57986 5.39865 2.73958 5.23893C2.89931 5.07921 3.09722 4.99935 3.33333 4.99935C3.56944 4.99935 3.76736 5.07921 3.92708 5.23893C4.08681 5.39865 4.16667 5.59657 4.16667 5.83268V16.666H12.5C12.7361 16.666 12.934 16.7459 13.0938 16.9056C13.2535 17.0653 13.3333 17.2632 13.3333 17.4993C13.3333 17.7355 13.2535 17.9334 13.0938 18.0931C12.934 18.2528 12.7361 18.3327 12.5 18.3327H4.16667Z"
          fill="#1E9435"
        />
      </g>
    </svg>
  );
}
